import { useState, createContext, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { themeCreator } from "./base";

export const ThemeContext = createContext(
	(_themeName) => { }
);

const ThemeProviderWrapper = (props) => {

	const [themeName, _setThemeName] = useState("GreyGooseTheme");

	useEffect(() => {
		const curThemeName = window.localStorage.getItem("appTheme") || "GreyGooseTheme";
		_setThemeName(curThemeName);
	}, []);

	const theme = themeCreator(themeName);
	const setThemeName = (themeName) => {
		window.localStorage.setItem("appTheme", themeName);
		_setThemeName(themeName);
	};
	if (props.disable) {
		return props.children;
	}
	return (
		<ThemeContext.Provider value={setThemeName}>
			<ThemeProvider theme={theme}>{props.children}</ThemeProvider >
		</ThemeContext.Provider>
	);
};


export default ThemeProviderWrapper;
